import { render, staticRenderFns } from "./SendRegistrationLinkEmailRepModal.vue?vue&type=template&id=bfe2b9fe&"
import script from "./SendRegistrationLinkEmailRepModal.vue?vue&type=script&lang=js&"
export * from "./SendRegistrationLinkEmailRepModal.vue?vue&type=script&lang=js&"
import style0 from "./SendRegistrationLinkEmailRepModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports